import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CookieState {
  value: boolean;
}

// Define the initial state using that type
const initialState: CookieState = { value: false };

export const cookiesSlice = createSlice({
  name: "cookies",
  initialState,
  reducers: {
    set: (state, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});
